module.exports = __webpack_public_path__ + "static/media/logo.ffdccf3c.jpg";